import GSAP from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

GSAP.registerPlugin(ScrollTrigger)

// var scrollTextAnimation
// var bannerAnimation

export function gsap() {
/*
	if (document.querySelector('.section--animated-banner .banner--masked')) {
		if (window.innerWidth > 1024) {
			// > 1600
			if (window.innerWidth > 1600) {
				var bannerAnimation = GSAP.timeline({
					scrollTrigger: {
						trigger: '.section--animated-banner .banner--masked',
						pin: true,
						scrub: true,
						start: 'top top',
						end: '+=1500',
					},
				})
					.to('.section--animated-banner .banner--masked .banner__content', { opacity: 0, duration: 1 }, '<')
					.to('.section--animated-banner .banner--masked .banner__content', { x: '50vh', duration: 1 }, '<')
					.to('.section--animated-banner .banner--masked .banner__media', { WebkitMaskPosition: '50% 3vh', duration: 1 }, '<')
					.to('.section--animated-banner .banner--masked .banner__media', { WebkitMaskSize: '500rem auto', duration: 5 }, '>')

			}

			// > 1350
			else if (window.innerWidth > 1350) {
				var bannerAnimation = GSAP.timeline({
					scrollTrigger: {
						trigger: '.section--animated-banner .banner--masked',
						pin: true,
						scrub: true,
						start: 'top top',
						end: '+=1500',
					},
				})
					.to('.section--animated-banner .banner--masked .banner__content', { opacity: 0, duration: 1 }, '<')
					.to('.section--animated-banner .banner--masked .banner__content', { x: '50vh', duration: 1 }, '<')
					.to('.section--animated-banner .banner--masked .banner__media', { WebkitMaskPosition: '50% 3vh', duration: 1 }, '<')
					.to('.section--animated-banner .banner--masked .banner__media', { WebkitMaskSize: '500rem auto', duration: 5 }, '>')

			}

			// else
			else {
				var bannerAnimation = GSAP.timeline({
					scrollTrigger: {
						trigger: '.section--animated-banner .banner--masked',
						pin: true,
						scrub: true,
						start: 'top top',
						end: '+=1500',
					},
				})
					.to('.section--animated-banner .banner--masked .banner__content', { opacity: 0, duration: 1 }, '<')
					.to('.section--animated-banner .banner--masked .banner__content', { x: '50vh', duration: 1 }, '<')
					.to('.section--animated-banner .banner--masked .banner__media', { WebkitMaskPosition: '50% 3vh', duration: 1 }, '<')
					.to('.section--animated-banner .banner--masked .banner__media', { WebkitMaskSize: '500rem auto', duration: 5 }, '>')

			}
		}
	}
*/
}
